<template>
 
	<div class="bk-color" style="margin-top: 45px;" :style="{ paddingBottom: showMoreContent ? '0' : '12px' }">

    <v-row class="icoev-header-row fixNotchMarginTop fixNotchPaddingBottom" style="height: 100px; max-height: 100px;">
			<v-col cols="12" class="icoev-header-title">
				<h4>
					<v-icon color="primary" style="top: -2px;">mdi-briefcase</v-icon>
					Bolsa de trabajo y bazar
				</h4>
				<!--<v-text-field 
					light solo flat
					class="search icoev-search-input"
					v-model="search"
					append-icon="mdi-magnify"
					label="Buscar..."
					:disabled="isLoading"
          @keyup="searchTimeOut()"/>-->			
        <v-select 
					outlined
					class="icoev-select"
          v-model="categoryId"
          :items="categories"
          item-text="text"
          item-value="id"
          label="Categoría"
          single-line
					:menu-props="{ maxHeight: 352 }"
					@input="searchTimeOut()"/>
			</v-col>
    </v-row>

    <div class="icoev-main-content-wrapper fixNotchMarginTop fixNotchPaddingBottom" style="top: 105px;">

    <v-row id="add-classified-button" v-if="!isLoading" align="center" justify="end" style="margin-right: 5px;">
      <v-btn text color="primary" @click="openUrl('https://www.icoev.es/lst_borsatreball/entra_anuncio.php?npag=1')">
        Crear Anuncio
        <v-icon right>
          mdi-open-in-new
        </v-icon>
      </v-btn>
    </v-row>	
		
    <v-skeleton-loader v-if="isLoading" type="card" class="mx-auto" max-width="90%"/>

		<v-alert v-if="!isLoading && items.length == 0" type="error" style="margin: 25px;">
			No se han encontrado datos
		</v-alert>

    <div v-for="item in items" :key="item.id">
			<v-card outlined class="mx-auto mt-2" max-width="95%">
				<v-card-text style="padding: 0;">
					<ClassifiedItem :data="item"/>
				</v-card-text>
			</v-card>
		</div>

		<v-row v-if="showMoreContent">
			<v-col style="text-align: center;">
				<a @click="addMoreContent()">Mostrar más contenido</a>
			</v-col>
		</v-row>

    </div> 
	</div>        
    
</template>

<script>
import api from '../../../api/icoev';
import BaseModule from "../../common/BaseModule";
import ClassifiedItem from "../../common/ClassifiedItem";
import cordova from "../../../api/cordova";

export default {
	name: 'BolsaTrabajoMain',
	mixins: [ BaseModule ],
	components: {
		ClassifiedItem
	},
	data () {
		return {
			isLoading: false,
			search: '',
			page: 0,
			items: [],
			selector: null,
			showMoreContent: false,
			isDirty: true,
			lastUpdate: null,
			categoryId: 0,	
			categories: [
				{ id: 0, text: 'Todas las categorías' },
				{ id: 1, text: 'Oferta de trabajo para dentistas' },
				{ id: 2, text: 'Oferta de trabajo para auxiliares' },
				{ id: 3, text: 'Demanda de trabajo para dentistas' },
				{ id: 4, text: 'Demanda de trabajo para auxiliares' },
				{ id: 5, text: 'Compra y venta de material' },
				{ id: 6, text: 'Venta y alquiler de clínicas' },
			],
		}
	},
	mounted() {
		this.$nextTick(() => {
			window.$vue.$on('ne_awake', this.processAwake);
		});
	},
	methods: {
		processAwake: function(seconds) {
			this.$log.debug("BolsaTrabajoMain - processAwake: " + seconds + " secs");
			if (seconds > this.MAX_UPDATE_DELAY_IN_SECONDS) {
				//this.$log.debug("BolsaTrabajoMain - processAwake: paused > 10 secs -> dirty = true");
				this.isDirty = true;
			}
		}, 
		searchTimeOut() {
			if (this.timer) {
				clearTimeout(this.timer);
				this.timer = null;
			}
			this.timer = setTimeout(() => {
				this.page = 0;
				this.showMoreContent = false;
				this.items = [];

				if (this.categoryId > 0) {
					var index = this.categories.findIndex(x => x.id == this.categoryId);

					this.search = this.categories[index].text;
				} else {
					this.search = '';
				}
				
				this.listarItems();
			}, 400);
		},    
		listarItems: function() {
			this.$log.debug("BolsaTrabajoMain - listarItems()");

			this.isLoading = true;

			api.getClassifieds(this.page, this.search ? this.search : '',
				res => {
					this.isLoading = false;
					
					if (!res.rsOK) {
						this.$emit('alert-event', { text: res.message, color: 'error', timeout: 3000 });
						return;
					}

					this.lastUpdate = new Date();

					if (res.entities.length == 0) {
						return;
					}
				
					this.items.push(...res.entities);

					this.showMoreContent = res.hasMoreData;

					if (this.selector) {
							this.$nextTick(() => {
							var anchor = this.$el.querySelector(this.selector);
							if (anchor) {
								anchor.scrollIntoView();
							}
						});
					}	
				},
				err => {               
					this.isLoading = false;     
					this.$log.error(err);
					this.$emit('alert-event', { text: 'Error al actualizar las ofertas/demandas de empleo', color: 'error', timeout: 3000 });
				}
			);
		},
		addMoreContent: function() {
			this.page++;
			this.selector = '#classified' + this.items[this.items.length - 1].id;
			this.showMoreContent = false;

			this.listarItems();
		},
		openUrl(url) {
			if (this.$store.state.icoev.device.platform == 'browser') {
				window.open(url);
			} else {
				cordova.openUrl(encodeURI(url));
			}
			//this.$emit('open-external-content', 'Crear anuncio', url);
		},
		reset() {			
			this.search = '';
			this.page = 0;
			this.items = [];
			this.selector = '#add-classified-button';
			this.showMoreContent = false;
			this.isDirty = true;			
			this.categoryId = 0;
		}
	},
	computed: {
		userChanged() {
			return this.$store.state.icoev.user;
		}
	},
	watch: {
		userChanged() {
			this.reset();
		},
		// eslint-disable-next-line no-unused-vars
		/*$route (to, from) {
			if (to.name !== 'bolsa-trabajo') {
				return;
			}

			//this.$log.debug("BolsaTrabajoMain - to.params.redirect: " + to.params.redirect);	
			if (to.params.redirect) {
				to.params.redirect = false;
				//this.$log.debug("BolsaTrabajoMain - clearCache()");
				api.clearClassifiedsCache();
				//this.$log.debug("BolsaTrabajoMain - reset()");
				this.reset();
			}
			//this.$log.debug("BolsaTrabajoMain - isDirty: " + this.isDirty);
			if (this.isDirty) {	
				this.isDirty = false;			
				this.$nextTick(() => {
					this.listarItems();
        });
				//this.$log.debug("BolsaTrabajoMain - isDirty: " + this.isDirty);
			}
		},*/
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			if (to.name !== 'bolsa-trabajo') {
				return;
			}

			if (vm.needsUpdate(vm.lastUpdate)) {
				vm.reset();
			}

			//vm.$log.debug("BolsaTrabajoMain - to.params.redirect: " + to.params.redirect);	
			if (to.params.redirect) {
				to.params.redirect = false;
				//vm.$log.debug("BolsaTrabajoMain - clearCache()");
				api.clearClassifiedsCache();
				//vm.$log.debug("BolsaTrabajoMain - reset()");
				vm.reset();
			}
			//vm.$log.debug("BolsaTrabajoMain - isDirty: " + vm.isDirty);
			if (vm.isDirty) {
				vm.isDirty = false;
				vm.$nextTick(() => {
					vm.listarItems();
        });
				//vm.$log.debug("BolsaTrabajoMain - isDirty: " + vm.isDirty);
			}
		})
	},
}
</script>

<style scoped>
  .media-object {
    width: 128px;
    padding: 10px;
  }

  .media {
    border-top: 1px solid lightgrey;
    padding-top: 20px;
    list-style-type: none;
  }
</style>